import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 w-full bg-white/20 backdrop-blur-md border-b border-gray-100 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            {/* <div className="text-2xl font-bold text-[#0A2540]">
              DigiStore
            </div> */}
            <img src="/logo_digistore2_logo.png" alt="DigiStore Logo" className="w-12 mr-2" />
            <img src="/logo_digistore2_png_text.png" alt="DigiStore Logo" className="w-36" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-gray-600 hover:text-[#5750f1] transition-colors duration-200">
              Características
            </a>
            <a href="#showcase" className="text-gray-600 hover:text-[#5750f1] transition-colors duration-200">
              Demo
            </a>
            <a href="#pricing" className="text-gray-600 hover:text-[#5750f1] transition-colors duration-200">
              Precios
            </a>
            <Button 
              variant="ghost" 
              className="text-gray-600 hover:text-[#5750f1]"
              onClick={() => window.open('https://panel.digistore.com.ar/auth/sign-in', '_blank')}
            >
              Iniciar Sesión
            </Button>
            <Button 
              className="bg-[#5750f1] hover:bg-[#442fff] text-white px-6 py-2 transition-all duration-200 transform hover:scale-105" 
              onClick={() => window.open('https://panel.digistore.com.ar/auth/sign-up', '_blank')}
            >
              Comenzar Ahora
            </Button>
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col space-y-4">
              <a href="#features" className="text-gray-600 hover:text-[#5750f1] transition-colors">
                Características
              </a>
              <a href="#showcase" className="text-gray-600 hover:text-[#5750f1] transition-colors">
                Demo
              </a>
              <a href="#pricing" className="text-gray-600 hover:text-[#5750f1] transition-colors">
                Precios
              </a>
              <Button variant="ghost" className="text-gray-600 hover:text-[#5750f1] justify-start px-0">
                Iniciar Sesión
              </Button>
              <Button className="bg-[#5750f1] hover:bg-[#442fff] text-white w-full">
                Comenzar Ahora
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};